module.exports = __webpack_public_path__ + "img/picture-earth.7086d403.jpg";